import { Outlet, useOutletContext } from 'react-router-dom';
import { AssetsLayout } from './Assets.layout';
import { AssetLayout } from './[Asset]/[Asset].layout';
import './translations';
import { RequirePermission } from 'components/auth/RequirePermission';
import { breadcrumbTranslation, getHmiTabBreadcrumb } from 'components/layout/Breadcrumb/utils';
import { AssetBreadcrumb } from 'components/layout/DynamicBreadcrumbs/AssetBreadcrumb';
import { BreadcrumbsRoute } from 'use-react-router-breadcrumbs';

const ContextForwardingOutlet = () => {
  const context = useOutletContext();
  return <Outlet context={context} />;
};

export const assetsRoutes: BreadcrumbsRoute[] = [
  {
    path: 'assets',
    breadcrumb: breadcrumbTranslation('assets'),
    element: <AssetsLayout />,
    children: [
      {
        path: 'multi-battery-graphs',
        breadcrumb: breadcrumbTranslation('assets-multi-battery-graphs'),
        element: (
          <RequirePermission permission="greenerUnit:create" redirectTo="/assets">
            <ContextForwardingOutlet />
          </RequirePermission>
        ),
        children: [
          {
            index: true,
            lazy: () => import('pages/Assets/MultiBatteryGraphs/MultiBatteryGraphs'),
          },
        ],
      },
      {
        path: ':unitExternalIdentifier',
        breadcrumb: AssetBreadcrumb,
        element: <AssetLayout />,
        children: [
          {
            index: true,
            lazy: () => import('pages/Assets/[Asset]'),
          },
          {
            path: 'graphs',
            breadcrumb: breadcrumbTranslation('assets-graphs'),
            lazy: () => import('pages/Assets/[Asset]/Graphs'),
          },
          {
            path: 'reports',
            breadcrumb: breadcrumbTranslation('assets-reports'),
            lazy: () => import('pages/Assets/[Asset]/AssetReports'),
          },
          {
            path: 'reports/create-report',
            breadcrumb: breadcrumbTranslation('assets-create-report'),
            lazy: () => import('pages/Assets/[Asset]/AssetReports/CreateReport'),
          },
          {
            path: 'hmi',
            breadcrumb: null,
            lazy: () => import('features/hmi/components/HmiTabs'),
          },
          {
            path: 'hmi/menu',
            breadcrumb: null,
            lazy: () => import('features/hmi/components/HmiMobileMenu'),
          },
          {
            path: 'hmi/:tab',
            breadcrumb: getHmiTabBreadcrumb('assets-hmi'),
            lazy: () => import('features/hmi/components/HmiTabs'),
          },
        ],
      },
    ],
  },
];
